import {
  AdserverUrnEnum,
  TRAFFICKING_PLATFORM_URN,
} from '@mint-sdk/api-integrations/compat';

export const getAdServerPlatformFrom = (platform?: string | null) => {
  if (!platform) return null;

  const parsed = AdserverUrnEnum.safeParse(platform);
  return parsed.success ? parsed.data : null;
};

export const getTraffickingPlatformFrom = (platform?: string | null) => {
  const adServerPlatform = getAdServerPlatformFrom(platform);

  if (adServerPlatform) {
    return adServerPlatform;
  }

  if (platform === TRAFFICKING_PLATFORM_URN.googleAnalytics) {
    return TRAFFICKING_PLATFORM_URN.googleAnalytics;
  }

  return null;
};

export const isAdserverAppsflyer = (platform?: string | null) => {
  const name = getAdServerPlatformFrom(platform);

  return !!name && name === TRAFFICKING_PLATFORM_URN.appsflyer;
};

export const isAdserverCM = (platform?: string) => {
  const name = getAdServerPlatformFrom(platform);

  return !!name && name === TRAFFICKING_PLATFORM_URN.campaignManager;
};

export const isTraffickingGA4 = (platform?: string) => {
  const name = getTraffickingPlatformFrom(platform);

  return !!name && name === TRAFFICKING_PLATFORM_URN.googleAnalytics;
};

export const isAdserverAdform = (platform?: string | null) => {
  const name = getAdServerPlatformFrom(platform);

  return !!name && name === TRAFFICKING_PLATFORM_URN.adform;
};
